import React, { useContext, useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useHistory } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { getAllArea } from '../../../service/areaService';
import { requestCanceller } from '../../../service/axiosCancelToken';
import { getAllPlaceCategories } from '../../../service/placeCategoryService';
import { deletePlaceById, getAllPlaces, getPlaceById } from '../../../service/placeService';
import DashboardContext from '../../context/dashboardContext';
import DeleteModal from '../../shared/DeleteModal';
import LoadingBar from '../../shared/LoadingBar';
import LoadingSpinner from '../../shared/LoadingSpinner';
import './AllPlaces.css';
import PlaceItem from './SinglePlace/PlaceItem';

const AllPlaces = () => {

    const [places, setPlaces] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const dashContext = useContext(DashboardContext);

    const [searchInput, setSearchInput] = useState('');
    const [lastItemId, setLastItemId] = useState('');
    const [hasMore, setHasMore] = useState(true);

    const placesRef = useRef(null);
    const placesCountRef = useRef(null);
    const [allDocumentsCounts, setAllDocumentsCounts] = useState();

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [deleteId, setDeleteId] = useState();

    const[deleteLoadingSpinner, setDeleteLoadingSpinner] = useState({flag: false, id:''});
    const[fetchLoadingSpinner, setFetchLoadingSpinner] = useState({flag: false, id:''});
    const[updateLoadingSpinner, setUpdateLoadingSpinner] = useState({flag: false, id:''});
    
    const onSearchHandler = (event) => {
        placesRef.current = null;
        let searched = event.target.value;
        setSearchInput(searched);
        setLastItemId('');
        setHasMore(true);
        setIsLoading(true);
    };

    useEffect(() => {
        if (places && placesCountRef && placesCountRef.current <= places.length) {
            setHasMore(false);
        }
    }, [places, placesCountRef]);

    const fetchMoreData = async () => {
        const lastItemId = places[places.length - 1]._id;
        setLastItemId(lastItemId);
    };

    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchAllPlaces = async () => {
            try {
                let params = { id: lastItemId, searchText: searchInput }
                let { status, data } = await getAllPlaces(params, { cancelToken: cancelRequest.signal });

                if (status === 201) {
                    placesCountRef.current = data.counts;
                    setAllDocumentsCounts(data.allDocs);

                    if (placesRef.current) {
                    placesRef.current = placesRef.current.concat(data.places);
                    setPlaces(placesRef.current);

                    }
                    else {
                        placesRef.current = data.places;
                        setPlaces(placesRef.current);
                    }
                    setIsLoading(false);
                }
            } catch (err) {

            }
        }
        fetchAllPlaces();
        return () => {
            cancelRequest.cancel();
        }
    }, [searchInput, lastItemId]);

    useEffect(() => {
        if(allDocumentsCounts && dashContext.placeCount !== allDocumentsCounts){
            dashContext.setPlaceCount(allDocumentsCounts);
        }
    }, [allDocumentsCounts, dashContext]);

    const history = useHistory();
    const { addToast } = useToasts();

    const deleteHandler = async (placeId) => {
        try {
            setDeleteLoadingSpinner({flag: true, id: placeId});
            const { status } = await deletePlaceById(placeId);
            if (status === 201) {
                addToast("کاربر مورد نظر حذف شد", {
                    appearance: 'success',
                    autoDismiss: true,
                })
                setDeleteLoadingSpinner({flag: false, id: ''});
                setAllDocumentsCounts(prev => --prev);
                dashContext.setPlaceCount(dashContext.placeCount - 1);
                let allItems = [...places];
                let filtered = allItems.filter(item => item._id !== placeId);
                setPlaces(filtered);
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                addToast("عدم دسترسی مجاز", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/login');
            }
            else if (err.response && err.response.status === 404) {
                addToast("چنین کاربری  وجود ندارد !", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/dashboard/questions')
            }
        }
    }

    const fetchPlace = async (placeId) => {
        try {

            setFetchLoadingSpinner({flag: true, id: placeId});
            let { status, data } = await getPlaceById(placeId);
            if(status === 201){
                setFetchLoadingSpinner({flag: false, id:''});
                history.push('/dashboard/place', {place: data.place})
            }

        } catch (err) {
            if(err.response && err.response.status === 404){
                addToast("چنین کاربری  وجود ندارد !", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/dashboard/place')
            }
        }
    } 
    
    const fetchPlaceForUpdate = async (placeId) => {
        try {
                setUpdateLoadingSpinner({flag: true, id:placeId});
                let { status, data } = await getPlaceById(placeId);
                let { status: status2, data: data2 } = await getAllArea({});
                let { status: status3, data: data3 } = await getAllPlaceCategories({});
                if(status3 === 201 && status2 === 201 && status === 201){
                    setUpdateLoadingSpinner({flag: false, id:''});
                    history.push('/dashboard/editplace', {
                        place: data.place,
                        areas: data2.areas,
                        placeCategories: data3.placeCategories
                    })

                }
          
        } catch (err) {
            if(err.response && err.response.status === 404){
                addToast("چنین کاربری  وجود ندارد !", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/dashboard/questions')
            }
        }
    } 



    useEffect(() => {
        if(deleteId)
        setShowDeleteDialog(true);
        else
        setShowDeleteDialog(false);
    },[deleteId]);
    
    return (
        <div className="places-container">
            <div className='d-flex flex-wrap  justify-content-center  text-center '>
                <div className="col-12">
                    <header className="d-flex flex-column flex-sm-row justify-content-around justify-content-sm-between">
                        <h1 className="all-places-header text-center text-sm-left">مدیریت مکان ها</h1>
                        <div className="d-flex mx-md-0 search-places ">
                            <span className="text-muted">
                                <i className="fa fa-search"></i>
                            </span>
                            <input
                                type="text"
                                placeholder="جستجو"
                                className="col inline-block form-control mb-3 mb-sm-0"
                                onChange={onSearchHandler}
                                value={searchInput}
                            />
                        </div>
                        <DeleteModal
                            show={showDeleteDialog}
                            closeModal={() => setDeleteId()}
                            deleteId={deleteId}
                            deleteHandler={deleteHandler}
                            
                        />
                    </header>
                    <div className="row justify-content-center">
                        {
                            (isLoading || !places) ?
                            <div style={{ height: '70vh' }} className="d-flex">
                                <div className="text-center align-self-center mx-auto">
                                    <LoadingSpinner />
                                </div>
                            </div>
                            :
                            <div className="col-12 col-sm-8 col-md-12 col-lg-12 col-xl-12 ">
                                <InfiniteScroll
                                    dataLength={places && places.length}
                                    next={fetchMoreData}
                                    hasMore={hasMore}
                                    loader={
                                        <div className="d-flex mt-2">
                                            <span className="mx-auto">
                                                <LoadingBar
                                                    type="spinningBubbles"
                                                    color="#0eac1b"
                                                />
                                            </span>
                                        </div>
                                    }
                                    endMessage={
                                        <p className="text-center mt-3">
                                            <b>The End</b>
                                        </p>
                                    }
                                >
                                    {
                                        places.map((place, index) =>
                                            <PlaceItem
                                                key={place._id}
                                                id={place._id}
                                                number={index + 1}
                                                title={place.title}
                                                image={place.placeImage}
                                                placeCategoryName={place.placeCategoryName}
                                                areaName={place.areaName}
                                                telephone={place.telephone}
                                                deletePlace={() => setDeleteId(place._id)}
                                                getPlaceInfo={() => fetchPlace(place._id)}
                                                getPlaceInfoForUpdate={() => fetchPlaceForUpdate(place._id)}
                                                deleteLoading={deleteLoadingSpinner}
                                                fetchLoading={fetchLoadingSpinner}
                                                updateLoading={updateLoadingSpinner}
                                            />
                                        )
                                    }
                                </InfiniteScroll>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AllPlaces;